import { ApiAddress } from 'api/types/ApiAddress';
import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { ApiSlideshowData } from 'api/types/ApiSlideshowData';
import { getJson } from 'utils/http';

export type Testimonial = {
  image: ApiFilestackImageData;
  text: string;
  name: string;
  year: string | number;
  degree: string;
  id: string | null | undefined;
};
export type GradFairId =
  | 'NYC'
  | 'BOS'
  | 'PHL'
  | 'WDC'
  | 'MSP'
  | 'CHI'
  | 'LAX'
  | 'SFO'
  | 'SEA'
  | 'ATL';

export type ApiGradProgram = {
  type: 'GRAD_PROGRAM';
  id: string;
  name: string;
  schoolName: string;
  description: string;
  descriptionTruncated: string | null | undefined;
  whatsSpecial: string;
  phone: string;
  email: string;
  address: ApiAddress;
  url: Record<string, string>;
  links: Array<string>;
  created: string;
  updated: string;
  org: {
    id: string;
    name: string;
    url: Record<string, string>;
    orgType: string;
  };
  logo: ApiFilestackImageData | null | undefined;
  banner: ApiFilestackImageData | null | undefined;
  slideshowItems: Array<ApiSlideshowData>;
  applicationGRE: boolean;
  applicationGMAT: boolean;
  applicationTOEFL: boolean;
  applicationIELTS: boolean;
  applicationPTE: boolean;
  applicationLettersRecomm2: boolean;
  applicationLettersRecomm3: boolean;
  applicationAcademicTranscripts: boolean;
  applicationPersonalStatement: boolean;
  additionalRequirements: string;
  nbOfStudents: number | null | undefined;
  maleStudents: number | null | undefined;
  femaleStudents: number | null | undefined;
  isHistoricallyBlack: boolean;
  hasDiversityOffice: boolean;
  isMinorityServing: boolean;
  careers: string | null | undefined;
  associations: string | null | undefined;
  applicationFee: number | null | undefined;
  avgInStateTuition: number | null | undefined;
  avgOutStateTuition: number | null | undefined;
  workStudyAvailable: boolean;
  financialAidIntl: boolean;
  applicationFeeWaiver: boolean;
  avgFinancialAid: number;
  applicationDeadline: string | null | undefined;
  testimonials: Array<Testimonial>;
  acceptanceRate: number;
  tuitionCustomItems: Array<string>;
  studentBodyCustomItems: Array<string>;
  admissionCustomItems: Array<string>;
  isHidden: boolean;
  areasOfStudy: Array<string>;
  degreeProgramsOffered: Array<string>;
  fairLocations: Array<GradFairId>;
};

export type ApiUnpublishedGradProgram = {
  id: string;
  type: 'UNPUBLISHED_GRAD_PROGRAM';
  org?: {
    id: string;
    name: string;
    url: Record<string, string>;
    orgType: string;
  };
};

export function fetchGradProgram(programId: string): Promise<ApiGradProgram> {
  return getJson(`/data/website/grad-programs/${programId}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ data, gradProgram }: { data: ... Remove this comment to see the full error message
    ({ data, gradProgram }) => data || gradProgram,
  );
}
